<template>
  <USlideover v-model="model">
  
        <div class="flex items-center justify-between p-4 border-b">
          <h3 class="text-base font-semibold leading-6 text-gray-900">
            {{ authStore.isAuthenticated ? 'Hesabım' : 'Giriş Yap' }}
          </h3>
          <UButton
            color="gray"
            variant="ghost"
            icon="i-heroicons-x-mark-20-solid"
            class="-my-1"
            @click="closeSlide"
          />
        </div>

      <!-- Content -->
      <!-- Giriş Yapmamış Kullanıcı -->
      <div v-if="!authStore.isAuthenticated">
        <PartialsFormAuthForm :redirect="false" @success="handleAuthSuccess" />
      </div>

      <!-- Giriş Yapmış Kullanıcı -->
      <div v-else>
        <nav class="space-y-2 mt-4">
          <NuxtLink
            v-for="item in menuItems"
            :key="item.link"
            :to="item.link"
            class="flex items-center gap-3 p-3 rounded-lg hover:bg-slate-50 transition-colors"
            @click="closeSlide"
          >
            <UIcon :name="item.icon" class="w-5 h-5 text-slate-500" />
            <span class="text-slate-700">{{ item.name }}</span>
          </NuxtLink>

          <button
            @click="handleLogout"
            class="flex items-center gap-3 p-3 rounded-lg hover:bg-red-50 transition-colors w-full text-left"
          >
            <UIcon
              name="i-heroicons-arrow-left-on-rectangle"
              class="w-5 h-5 text-red-500"
            />
            <span class="text-red-600">Çıkış Yap</span>
          </button>
        </nav>
      </div>
  </USlideover>
</template>

<script setup>
const model = defineModel()
const authStore = useAuthStore()
const uiStore = useUiStore()
const toast = useCustomToast()

const menuItems = [
  {
    name: 'Siparişlerim',
    link: '/hesap/siparislerim',
    icon: 'i-heroicons-shopping-bag'
  },
  {
    name: 'Adreslerim',
    link: '/hesap/adreslerim',
    icon: 'i-heroicons-map-pin'
  },
  {
    name: 'Favorilerim',
    link: '/hesap/favorilerim',
    icon: 'i-heroicons-heart'
  },
  {
    name: 'Hesap Ayarları',
    link: '/hesap/ayarlar',
    icon: 'i-heroicons-cog-6-tooth'
  }
]

const closeSlide = () => {
  uiStore.accountSlide = false
}

const handleAuthSuccess = () => {
  toast.success('Başarıyla giriş yaptınız')
  closeSlide()
}

const handleLogout = async () => {
  await authStore.logout()
  toast.success('Başarıyla çıkış yaptınız')
  closeSlide()
}
</script>
